<template>
  <el-menu :default-active="activeMenu">
    <sidebar-item
      v-for="(route, index) in menu_routes"
      :key="index"
      :item="route"
      :base-path="route.path"
    />
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["menu_routes"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    variables() {
      return variables;
    }
  }
};
</script>

<style scoped lang="less">
::v-deep.el-menu {
  border: none;
  .el-menu-item {
    font-size: 18px;
    color: rgba(153, 153, 153, 1);
    margin-bottom: 30px;
    padding: 0 !important;
    &.is-active {
      color: #fff;
      background-color: #1b9cee;
      border-radius: 5px;
    }
    &:focus,
    &:hover {
      background-color: #1b9cee;
      border-radius: 5px;
      color: #fff;
    }
    & * {
      vertical-align: top;
    }
  }
}
</style>
